"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlowMeter = void 0;
const datamodel_core_1 = require("@iotv/datamodel-core");
const typeName = 'FlowMeter';
class FlowMeter extends datamodel_core_1.DeviceEnabledType {
    constructor(ob) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        super(ob.type || typeName, ob);
        this.purposeType = (_a = ob.purposeType) !== null && _a !== void 0 ? _a : '';
        this.maximumFlowRate = ob.maximumFlowRate ? (typeof ob.maximumFlowRate === 'string' ? parseInt(ob.maximumFlowRate) : ob.maximumFlowRate) : null;
        this.flow = (_b = ob.flow) !== null && _b !== void 0 ? _b : null;
        this.location = (_c = ob.location) !== null && _c !== void 0 ? _c : ob.position;
        this.pulseFlowAmount = ob.pulseFlowAmount ? (typeof ob.pulseFlowAmount === 'string' ? parseInt(ob.pulseFlowAmount) : ob.pulseFlowAmount) : 1;
        this.flowPerPulse = (_e = (_d = ob.flowPerPulse) !== null && _d !== void 0 ? _d : ob.flowperpulse) !== null && _e !== void 0 ? _e : null;
        this.lifetimeCount = (_f = ob.lifetimeCount) !== null && _f !== void 0 ? _f : null;
        this.periodicCount = (_g = ob.periodicCount) !== null && _g !== void 0 ? _g : null;
        this.periodFlow = (_h = ob.periodFlow) !== null && _h !== void 0 ? _h : 0;
        this.flowToday = (_j = ob.flowToday) !== null && _j !== void 0 ? _j : null;
        this.flowYesterday = (_k = ob.flowYesterday) !== null && _k !== void 0 ? _k : null;
        this.periodLength = (_l = ob.periodLength) !== null && _l !== void 0 ? _l : null;
        this.flowRate = (_m = ob.flowRate) !== null && _m !== void 0 ? _m : null;
    }
    getUserAttributes() {
        return {
            ...super.getUserAttributes(),
            name: {
                type: 'String',
                editable: true,
                label: 'Name',
                name: 'name',
                description: 'Name of Water Flow Meter',
            },
            purposeType: {
                type: 'String',
                editable: true,
                label: 'Purpose/ Type',
                name: 'purpose/Type',
                description: 'Purpose/ type of Flow',
            },
            meterType: {
                type: 'String',
                editable: true,
                label: 'Meter Type',
                name: 'meterType',
                description: 'Meter type',
            },
            diameter: {
                type: 'Number',
                editable: true,
                label: 'Diameter',
                name: 'diameter',
                description: 'Diameter of Water Flow pipe - mm',
            },
            maximumFlowRate: {
                type: 'Number',
                editable: true,
                label: 'Maximum Flow Rate (L/m)',
                name: 'maximumFlowRate',
                description: 'Maximum flow rate ',
            },
            // setFlowRate: {
            //   type: "Number",
            //   editable: true,
            //   label: "Set Flow Rate",
            //   name: "setFlowRate",
            //   description: "Flow rate set for the Water Flow",
            // },
            // flow: {
            //   type: "Number",
            //   editable: true,
            //   label: "Flow",
            //   name: "flow",
            //   description: "Water flow  litres/ sec and cubic metres/ sec",
            // },
            location: {
                type: 'object',
                editable: true,
                label: 'Location',
                name: 'location',
                description: 'Location of  Water Flow Meter (lat/ long)',
            },
            // pulseCounterFrequency: {
            //   type: "Number",
            //   editable: true,
            //   label: "Pulse counter frequency",
            //   name: "pulseCounterFrequency",
            //   description: "Frequency of pulse counts from meter to measure flow",
            // },
            pulseFlowAmount: {
                type: 'Number',
                editable: true,
                label: 'Flow (Liters) per pulse',
                name: 'pulseFlowAmount',
                description: 'Flow per pulse to calculate water flow',
            },
            comments: {
                type: 'String',
                editable: true,
                label: 'Comments',
                name: 'comments',
                description: 'Free text for info ',
            },
        };
    }
}
exports.FlowMeter = FlowMeter;
